import React, { useEffect } from "react";
import "./index.css";
import { Redirect } from "react-router-dom";
import { Form, Input, Button, message, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";
import { logger } from "../../../utils";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import {
  loginWithPassword,
  setPhoneNumber,
} from "../../../application/login-slice";
import { checkAuthentication } from "../../../application/auth-slice";

const { Item, useForm } = Form;
const { Title } = Typography;

export default function Login() {
  const { loading, failure, phoneNumber } = useAppSelector(
    (state) => state.login
  );
  const [form] = useForm();
  const dispatch = useAppDispatch();

  const onLoginWithPassword = async () => {
    try {
      await form.validateFields();
      dispatch(loginWithPassword(form.getFieldValue("password")));
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    if (loading === "failed") {
      failure?.maybeMap({
        wrongPasswordFailure: () => {},
        orElse: () => message.error(I18n.general.networkError),
      });
    }
  }, [loading, failure]);

  if (loading === "succeeded") {
    dispatch(checkAuthentication());
    return <Redirect to="/" />;
  }

  const isLoading = loading === "pending";
  return (
    <DocumentTitle title={I18n.loginAuth.title}>
      <div className="login-form">
        <Title className="login-form-title">{I18n.title}</Title>
        <Title level={4}>{I18n.loginAuth.title}</Title>
        <Form
          form={form}
          fields={[{ name: "phone-number", value: phoneNumber }]}
        >
          <Item
            name="phone-number"
            rules={[
              {
                required: true,
                message: I18n.loginRegister.phoneEmptyError,
                validateTrigger: "onSubmit",
              },
              {
                min: 11,
                max: 11,
                len: 11,
                message: I18n.loginRegister.phoneInvalidError,
                validateTrigger: "onSubmit",
              },
            ]}
          >
            <Input
              required={true}
              inputMode="tel"
              autoComplete="username"
              placeholder={I18n.general.phoneNumber}
              disabled={loading === "pending"}
              maxLength={11}
              spellCheck={false}
              allowClear
              onChange={(value) => {
                dispatch(setPhoneNumber(value.target.value));
                form.setFields([{ name: "phone-number", value: phoneNumber }]);
              }}
            />
          </Item>
          <Item
            name="password"
            validateStatus={failure?.maybeMap({
              wrongPasswordFailure: () => "error",
              orElse: () => undefined,
            })}
            help={failure?.maybeMap({
              wrongPasswordFailure: () => I18n.loginAuth.wrongPassword,
              orElse: () => undefined,
            })}
            rules={[
              {
                required: true,
                message: I18n.general.passwordErrors.empty,
                validateTrigger: "onSubmit",
              },
            ]}
          >
            <Input.Password
              required={true}
              placeholder={I18n.general.password}
              className={
                form.getFieldValue("password") === "" ||
                form.getFieldValue("password") === undefined
                  ? ""
                  : "login-form-password-input"
              }
              autoComplete="current-password"
              disabled={isLoading}
              spellCheck={false}
            />
          </Item>
          <Item>
            <Button
              type="primary"
              block
              onClick={onLoginWithPassword}
              disabled={isLoading}
              loading={isLoading}
            >
              {I18n.loginAuth.title}
            </Button>
          </Item>
        </Form>
      </div>
    </DocumentTitle>
  );
}
